export default [
	{
		path: 'machines',
		name: 'StudentMachines',
		component: () => import('@/pages/student/components/machine/Machines'),
	},
	{
		path: 'machine/:machineId/ssh',
		name: 'StudentMachineSsh',
		component: () => import('@/pages/student/components/machine/StudentMachineSsh'),
	},
];
